const BASE = 'user/profile';

export const PATHS = {
  BASE,
  PERSONAL: BASE,
  SECURITY: `${BASE}/security`,
  NOTIFICATIONS: `${BASE}/notifications`,
  SETTINGS: `${BASE}/settings`,
} as const;

export const PROFILE_TAB_SEGMENTS = {
  personal: '',
  security: 'security',
  notifications: 'notifications',
  settings: 'settings',
} as const;

export type ProfileTabKey = keyof typeof PROFILE_TAB_SEGMENTS;

export const PROFILE_TAB_KEYS: ProfileTabKey[] = [
  'personal',
  'security',
  'notifications',
  'settings',
];

export const getProfileTabPath = (baseUrl: string, tab: ProfileTabKey): string => {
  const segment = PROFILE_TAB_SEGMENTS[tab];
  return segment ? `${baseUrl}/${segment}` : baseUrl;
};

/** Personal-data edit drawer — narrow form, not full admin width */
export const EDIT_PROFILE_DRAWER_WIDTH = 520;
